<template>
  <div class="member-center" style="padding-top: 1rem">
    <navTitle :title="
        $router.app._route.query.ti ? $router.app._route.query.ti : 'Member center'
      "></navTitle>

    <div class="header">
      <div class="slider-banner banner">
        <swiper class="swiper-wrapper" :options="swiperVip" ref="mySwiper">
          <swiperSlide class="swiper-slide memberBg" :class="item.class" v-for="(item, index) in vipList"
            :style="{ backgroundImage: 'url(' + item.image + ')' }">
            <!--            <img :src="item.icon" />-->
            <div class="name">{{ item.name }}</div>

            <div class="discount">
              Mampu membeli item pada {{ item.discount / 10 }} off
              <span class="iconfont icon-zhekou"></span>
            </div>
            <div class="discount v-html" v-html="item.explain"></div>
            <!--<div class="nav acea-row" v-if="item.grade == grade">-->
            <!--<div-->
            <!--class="item"-->
            <!--v-for="(val, indexn) in vipComplete"-->
            <!--:key="indexn"-->
            <!--&gt;-->
            <!--<div class="num">{{ val.number }}</div>-->
            <!--<div>{{ val.real_name }}</div>-->
            <!--</div>-->
            <!--</div>-->
            <div class="lock" v-if="item.grade > grade">
              <span class="iconfont icon-quanxianguanlisuozi"></span>VIP level unlocked
            </div>

            <div class="lock" v-if="item.grade < grade">
              <span class="iconfont icon-xuanzhong1"></span>Higher level unlocked
            </div>
          </swiperSlide>
        </swiper>
      </div>
    </div>
    <div class="wrapper">
      <div class="title acea-row row-between-wrapper">
        <div><span class="iconfont icon-jingyanzhi"></span>Persyaratan upgrade VIP</div>
        <div class="num">
          <span class="current">{{ taskCount }}</span>/{{
            vipList[activeIndex].task_list.task.length +
              (vipList[activeIndex].task_list.one_task.length > 0 ? 1 : 0)
          }}
        </div>
      </div>
      <!--vip必选任务-->
      <div class="list">
        <div class="info" v-if="vipList[activeIndex].task_list.task.length">
          hal yang diperlukanRequired tasks
        </div>
        <div class="item" v-for="(item, index) in vipList[activeIndex].task_list.task">
          <div class="top acea-row row-between-wrapper">
            <div class="name">
              {{ item.name }}
              <span class="iconfont icon-wenti" v-if="item.illustrate" @click="showGrow(item)"></span>
            </div>
            <div>{{ item.finish ? "Selesai" : "Belum selesai" }}</div>
          </div>
          <div class="cu-progress">
            <div class="bg-red" :style="{ width: item.speed + '%' }"></div>
          </div>
          <div class="experience acea-row row-between-wrapper">
            <div>{{ item.task_type_title }}</div>
            <div>
              <span class="num">{{ item.new_number }}</span>/{{ item.number }}
            </div>
          </div>
        </div>
        <!--可选任务-->
        <div class="info" v-if="vipList[activeIndex].task_list.one_task.length">
          Please select one of below
        </div>
        <div class="item" v-for="(item, index) in vipList[activeIndex].task_list.one_task">
          <div class="top acea-row row-between-wrapper">
            <div class="name">
              {{ item.name
              }}<span class="iconfont icon-wenti" v-if="item.illustrate" @click="showGrow(item)"></span>
            </div>
            <div>{{ item.finish ? "Selesai" : "Belum selesai" }}</div>
          </div>
          <div class="cu-progress">
            <div class="bg-red" :style="{ width: item.speed + '%' }"></div>
          </div>
          <div class="experience acea-row row-between-wrapper">
            <div>{{ item.task_type_title }}</div>
            <div>
              <span class="num">{{ item.new_number }}</span>/{{ item.number }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <CouponPop v-on:changeFun="changeFun" :vip_grade="activeIndex + 1"
      :coupon="vipList[activeIndex].task_list.coupon_list"></CouponPop>
    <Recommend></Recommend>
    <div class="growthValue" :class="growthValue === false ? 'on' : ''">
      <div class="pictrue">
        <img src="@assets/images/value.jpg" /><span class="iconfont icon-guanbi3" @click="growthTap"></span>
      </div>
      <div class="conter">
        {{ illustrate }}
      </div>
    </div>
    <div class="mask" :hidden="growthValue" @click="growthTap"></div>
  </div>
</template>
<script>
  import { swiper, swiperSlide } from "vue-awesome-swiper";
  import "@assets/css/swiper.min.css";
  import Recommend from "@components/Recommend";
  import navTitle from "@components/navTitle";
  import CouponPop from "@components/VipCouponPop";

  import { getVipInfo, getVipTask, setDetection } from "../../api/user";
  export default {
    name: "Poster",
    components: {
      swiper,
      swiperSlide,
      Recommend,
      navTitle,
      CouponPop
    },
    props: {},
    data: function () {
      const self = this;
      return {
        vipList: [], //包含本页面所有数据
        grade: 0, //当前会员等级,
        swiperVip: {
          speed: 1000,
          effect: "coverflow",
          slidesPerView: "auto",
          centeredSlides: true,
          // loop: true,
          coverflowEffect: {
            rotate: 0, // 旋转的角度
            stretch: -20, // 拉伸   图片间左右的间距和密集度
            depth: 100, // 深度   切换图片间上下的间距和密集度
            modifier: 2, // 修正值 该值越大前面的效果越明显
            slideShadows: false // 页面阴影效果
          },
          observer: true,
          observeParents: true,
          on: {
            // 使用es6的箭头函数，使this指向vue对象
            slideChangeTransitionEnd: function () {
              self.activeIndex = this.activeIndex;
              self.getTask();
            },
            slideTo: function (index) {
              this.slideTo(index);
            }
          }
        },
        loading: false,
        growthValue: true,
        illustrate: "",
        activeIndex: 0
      };
    },
    watch: {},
    computed: {},
    mounted: function () {
      let that = this;
      setDetection();
      that.getInfo();
    },
    methods: {
      //将父级向子集多次传送的函数合二为一；
      changeFun: function (opt) {
        if (typeof opt !== "object") opt = {};
        let action = opt.action || "";
        let value = opt.value === undefined ? "" : opt.value;
        this[action] && this[action](value);
      },

      growthTap: function () {
        this.growthValue = true;
      },
      getInfo: function () {
        let that = this;
        getVipInfo().then(
          res => {
            res.data.list.forEach((item, index) => {
              res.data.list[index].explain = item.explain.replace(
                /\n/gm,
                "<br/>"
              );
            });
            that.vipList = res.data.list;
            that.grade = res.data.user_now_level;
            that.$nextTick(() => {
              // console.log('res.data.user_now_level',res.data.user_now_level)
              that.$refs.mySwiper.swiper.slideTo(res.data.user_now_level);
              if (res.data.user_now_level == 0) {
                that.getTask();
              }
            });
          },
          err => {
            that.$dialog.message(err.msg);
          }
        );
      },
      getTask: function () {
        let that = this;
        this.$dialog.loading.open("Loading...");
        getVipTask(that.vipList[that.activeIndex].id).then(
          res => {
            this.vipList[this.activeIndex].task_list.task = res.data.task;
            this.vipList[this.activeIndex].task_list.one_task = res.data.one_task;
            this.taskCount = res.data.reach_count;
            this.$dialog.loading.close();

            // that.vipRequire = res.data.list;
            // that.vipComplete = res.data.task;
            // that.taskCount = res.data.reach_count;
            // that.onevipComplete = res.data.one_task;

            // that.vipRequire = res.data.list;
            // that.vipComplete = res.data.task;
            // that.onevipComplete = res.data.one_task;
            // that.taskCount = res.data.reach_count;
            // that.coupon.list = res.data.reach_count;
            // that.$set(that.coupon, "list", res.data.coupon_list);
          },
          err => {
            this.$dialog.loading.close();
            that.$dialog.message(err.msg);
          }
        );
      },
      showGrow: function (item) {
        if (this.illustrate != item.illustrate) this.illustrate = item.illustrate;
        this.growthValue = false;
      }
    }
  };
</script>
<style>
  .info {
    width: 100%;
    line-height: 0.5rem;
    height: 0.5rem;
    color: #999;
    text-align: center;
    margin-bottom: 0.4rem;
    /*background: #f0f0f0;*/
  }
</style>